import {atom} from 'jotai';

import {Features} from '@lexian/api/support-api';

export const featureFlagState = atom<Features>({
  advancePaymentRequest: false,
  allEmails: false,
  clientMoney: false,
  clientSidePdfGeneration: false,
  digitalSigning: false,
  globalTasks: false,
  justitia: false,
  notes: false,
  invoiceAmendment: false,
  obligations: false,
  timeTracker: false,
});
